module.exports = __webpack_public_path__ + "img/birthday.ba844067.jpg";